import * as React from 'react';
import { useEffect } from 'react';
import { useAuthContext } from '../../contexts/Auth';
import { useHistory } from 'react-router';
import { pathname, forwardUrlParams } from '../../utils';
import { Auth } from 'aws-amplify';
import { useSnackbarContext } from '../../contexts/Snackbar';
import { useIntl } from 'react-intl';
import Layout from '../../components/auth/Layout';
import ForgotPassword from '../../components/auth/ForgotPassword';

export default function Forgot() {
  const history = useHistory();
  const { signedIn } = useAuthContext();
  const snackbar = useSnackbarContext();
  const { formatMessage: f } = useIntl();

  useEffect(() => {
    signedIn && history.push(pathname.dashboard.url);
  }, [signedIn, history]);

  return (
    <Layout title="Forgot Password">
      <ForgotPassword
        gotToSignIn={() =>
          history.push({
            pathname: pathname.preLogin.login.url,
            search: forwardUrlParams(),
          })
        }
        onSubmit={async (email) => {
          await Auth.forgotPassword(email)
            .then(() => {
              snackbar.show(
                f({ id: 'auth.resetPasswordInstructions' }),
                'success',
              );
            })
            .catch((err) => {
              snackbar.show(f({ id: 'auth.resetPasswordError' }), 'error');
            });
        }}
      />
    </Layout>
  );
}
